import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYoutube from 'vue-youtube'

import VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'

import './assets/tailwind.css';
import './assets/styles/index.css';

import PrismicVue from '@prismicio/vue'
import linkResolver from './link-resolver' // Update this path if necessary


import Timeline from './pages/Timeline.vue'
import Entry from './components/Entry.vue'

const accessToken = '' // Leave empty if your repo is public
const endpoint = 'https://wirtualnemuzeumprzemowien.prismic.io/api/v2' // Use your repo name

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueYoutube);
Vue.use(VueCompositionAPI);

Vue.use(PrismicVue, {
            endpoint,
            apiOptions: { accessToken },
            linkResolver
});

var title = "Wirtualne Muzeum Przemówień";

const router = new VueRouter({
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/entry/:id',
            name: 'entry',
            component: Entry
        },
        {
            path: '/wpis/:id',
            name: 'entry',
            component: Entry
        },
        {
            path: '/',
            name: 'home',
            component: Timeline
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = title;
    next();
});

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app')
